<template>
  <BSkeletonWrapper
    :loading="loading"
  >
    <template #loading>
      <BCard>
        <BCardText>
          <div class="d-flex flex-column justify-content-center mb-3">
            <BSkeleton
              width="65%"
              height="23px"
              class="mb-2"
            />
            <BSkeleton
              width="80%"
              height="18px"
            />
          </div>
        </BCardText>

        <BCardText>
          <BRow class="gap-y-2">
            <BCol
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>
          </BRow>
        </BCardText>
      </BCard>
    </template>

    <BCard>
      <BCardText
        style="font-size: 0.8rem;"
      >
        <BRow class="gap-y-2">
          <BCol
            cols="12"
          >
            <BRow class="gap-y-2 mt-2 mt-md-0">
              <BCol
                cols="12"
              >
                <i class="fad fa-people-pulling text-secondary" />
                Customer Progress
              </BCol>
              <BCol
                cols="12"
                class="mt-2"
                style="font-size: 0.7rem;"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <b>{{ currentProgress.customer }}</b> Attended / <b>{{ totalProgress.customer }}</b> Target
                  </div>
                  <div>
                    <b :class="`text-${customerVariant}`">{{ (customerProgress).toFixed(2) }}</b> %
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            class="border-bottom"
          />

          <BCol
            cols="12"
          >
            <BRow class="gap-y-2 mt-2 mt-md-0">
              <BCol
                cols="12"
              >
                <i class="fad fa-earth-asia text-danger" />
                Hectare Progress
              </BCol>
              <BCol
                cols="12"
                class="mt-2"
                style="font-size: 0.7rem;"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <b>{{ numberFormatter(currentProgress.hectare) }}</b> Actual / <b>{{ numberFormatter(totalProgress.hectare) }}</b> Target
                  </div>
                  <div>
                    <b :class="`text-${hectareVariant}`">{{ (hectareProgress).toFixed(2) }}</b> %
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            class="border-bottom"
          />

          <BCol
            cols="12"
          >
            <BRow class="gap-y-2 mt-2 mt-md-0">
              <BCol
                cols="12"
              >
                <i class="fad fa-coin text-warning" />
                Generated Sales
              </BCol>
              <BCol
                cols="12"
                class="mt-2"
                style="font-size: 0.7rem;"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <b>{{ numberFormatter(currentProgress.sales) }}</b> Sales / <b>{{ numberFormatter(totalProgress.sales) }}</b> Target
                  </div>
                  <div>
                    <b :class="`text-${salesVariant}`">{{ (salesProgress).toFixed(2) }}</b> %
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            class="border-bottom"
          />

          <BCol
            cols="12"
          >
            <BRow class="gap-y-2 mt-2 mt-md-0">
              <BCol
                cols="12"
              >
                <i class="fad fa-coin text-info" />
                Budget
              </BCol>
              <BCol
                cols="12"
                class="mt-2"
                style="font-size: 0.7rem;"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <b>{{ numberFormatter(currentProgress.cost) }}</b> Spent / <b>{{ numberFormatter(totalProgress.cost) }}</b> Allotted
                  </div>
                  <div>
                    <b :class="`text-${costVariant}`">{{ (costProgress).toFixed(2) }}</b> %
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>

          <BCol
            cols="12"
            class="border-bottom"
          />

          <BCol
            cols="12"
          >
            <BRow class="gap-y-2 mt-2 mt-md-0">
              <BCol
                cols="12"
              >
                <i class="fad fa-percent text-dark" />
                Conversion Rate
              </BCol>
              <BCol
                cols="12"
                class="mt-2"
                style="font-size: 0.7rem;"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <b>{{ activity.total_buyers }}</b> Bought / <b>{{ currentProgress.customer }}</b> Attended
                  </div>
                  <div>
                    <b :class="`text-${conversionRateVariant}`">{{ (conversionRate).toFixed(2) }}</b> %
                  </div>
                </div>
              </BCol>
            </BRow>
          </BCol>

        </BRow>
      </BCardText>

      <BCardText>
        <slot name="footer" />
      </BCardText>
    </BCard>
  </BSkeletonWrapper>
</template>
<script>
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'VAuditDashboardAreaManagerTasks',

  mixins: [
    MxFormatter
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    activity: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        activity_name: '',
        total_buyers: 0
      })
    },
    totalProgress: {
      type: Object,
      required: true,
      default: () => ({
        customer: 0,
        hectare: 0,
        cost: 0,
        sales: 0
      })
    },
    currentProgress: {
      type: Object,
      required: true,
      default: () => ({
        customer: 0,
        hectare: 0,
        cost: 0,
        sales: 0
      })
    }
  },

  computed: {

    customerProgress () {
      const customers = this.currentProgress.customer / this.totalProgress.customer
      if (isNaN(customers) || !isFinite(customers)) {
        return 0
      }

      return customers * 100
    },

    customerVariant () {
      if (this.customerProgress >= 75) {
        return 'success'
      } else if (this.customerProgress >= 31) {
        return 'warning'
      } else if (this.customerProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    },

    hectareProgress () {
      const hectares = this.currentProgress.hectare / this.totalProgress.hectare
      if (isNaN(hectares) || !isFinite(hectares)) {
        return 0
      }

      return hectares * 100
    },

    hectareVariant () {
      if (this.hectareProgress >= 75) {
        return 'success'
      } else if (this.hectareProgress >= 31) {
        return 'warning'
      } else if (this.hectareProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    },

    conversionRate () {
      const rates = this.activity.total_buyers / this.currentProgress.customer
      if (isNaN(rates) || !isFinite(rates)) {
        return 0
      }

      return rates * 100
    },

    conversionRateVariant () {
      if (this.conversionRate >= 75) {
        return 'success'
      } else if (this.conversionRate >= 31) {
        return 'warning'
      } else if (this.conversionRate >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    },

    costProgress () {
      const costs = this.currentProgress.cost / this.totalProgress.cost
      if (isNaN(costs) || !isFinite(costs)) {
        return 0
      }

      return costs * 100
    },

    costVariant () {
      if (this.costProgress >= 75) {
        return 'success'
      } else if (this.costProgress >= 31) {
        return 'warning'
      } else if (this.costProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    },

    salesProgress () {
      const sales = this.currentProgress.sales / this.totalProgress.sales
      if (isNaN(sales) || !isFinite(sales)) {
        return 0
      }

      return sales * 100
    },

    salesVariant () {
      if (this.salesProgress >= 75) {
        return 'success'
      } else if (this.salesProgress >= 31) {
        return 'warning'
      } else if (this.salesProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    }

  },

  methods: {
    variant () {
      // todo: create officer
    }
  }
}
</script>
